import { render, staticRenderFns } from "./CustomerReservations.vue?vue&type=template&id=3aa720bf&scoped=true"
import script from "./CustomerReservations.vue?vue&type=script&lang=js"
export * from "./CustomerReservations.vue?vue&type=script&lang=js"
import style0 from "./CustomerReservations.vue?vue&type=style&index=0&id=3aa720bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa720bf",
  null
  
)

export default component.exports